import { Action } from '@ngrx/store';

import { ReadingListDetails } from '®shared/reading-list';

export enum ListsForResourceActionTypes {
  FETCH_LISTS_FOR_RESOURCE = '[Lists For Resource] Fetch Lists',
  FETCH_LISTS_FOR_RESOURCE_SUCCESS = '[Lists For Resource] Fetch Lists Success',
  FETCH_LISTS_FOR_RESOURCE_FAILED = '[Lists For Resource] Fetch Lists Failed',
}

export interface ListsForResourcePayload {
  resourceId: string;
}

export interface ListsForResourceDataPayload {
  listsForResourceData: ReadingListDetails[];
}

export class FetchListsForResource implements Action {
  readonly type = ListsForResourceActionTypes.FETCH_LISTS_FOR_RESOURCE;

  constructor(public payload: ListsForResourcePayload) {}
}

export class FetchListsForResourceSuccessAction implements Action {
  readonly type = ListsForResourceActionTypes.FETCH_LISTS_FOR_RESOURCE_SUCCESS;

  constructor(public payload: ListsForResourceDataPayload) {}
}
export class FetchListsForResourceFailedAction implements Action {
  readonly type = ListsForResourceActionTypes.FETCH_LISTS_FOR_RESOURCE_FAILED;

  constructor(public payload: { error: unknown }) {}
}

export type ListsForResourceActions =
  | FetchListsForResource
  | FetchListsForResourceSuccessAction
  | FetchListsForResourceFailedAction;
